module.exports = __webpack_public_path__ + "static/media/expand-icon.deafe45e.svg";